<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <!-- //header -->
      <SubHeaderWithSidebar :title="headerTitle" />
      <!-- //header -->
      <Gnb v-if="showGnb" />

      <div id="container" ref="container">
        <section id="contents">
          <div class="nonRealWrap">
            <h5 class="subtitle">Non-real {{headerTitle}}</h5>
            <div class="nonReal">
              <ul>
                <li v-bind:key="quiz.id" v-for="quiz in quizs" @click.prevent="golist(quiz)">
                  <div class="num">{{quiz.RNum}}</div>
                  {{quiz.title}}
                </li>
                <li v-if="quizs.length === 0" style="text-align:center;">등록된 자료가 없습니다.</li>
              </ul>
            </div>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import Gnb from "@/components/Gnb";
import router from "@/router";
import sideMixin from "@/components/SideMixin";
import * as R from "ramda";
export default {
  mixins: [sideMixin],
  components: { SubHeaderWithSidebar, Gnb },
  created() {
    let non_type = this.$route.params.non_type;
    this.$store.dispatch("loadNonFullList", non_type).catch(err => {});
  },
  beforeRouteUpdate(to, from, next) {
    let non_type = to.params.non_type;
    this.$store.dispatch("loadNonFullList", non_type).catch(err => {});
    next();
  },

  computed: {
    headerTitle() {
      let non_type = this.$route.params.non_type;
      return non_type === "quiz" ? "Quiz" : "Survey";
    },
    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    quizs: function() {
      let k = this.$store.state.paper_quiz;

      let _num = 1;
      k = R.map(x => {
        x.RNum = _num++;
        return x;
      }, k);

      return k;
    }
  },
  methods: {
    golist: function(quiz) {
      router.push("/non/paper/" + quiz.id);
    }
  }
};
</script>

<style lang="scss" scoped>
#contents {
  height: 100vh;
  padding-top: 55px;
}
.nonRealWrap {
  padding: 30px 20px 0;
  text-align: center;
}
.nonReal {
  margin-top: 60px;
}
.nonReal ul {
}
.nonReal ul li {
  text-align: left;
  background: #ffffff;
  box-shadow: 5px 5px 6px 2px rgba(0, 0, 0, 0.3);
  padding: 25px 25px 25px 50px;
  margin-bottom: 20px;
  border-radius: 10px;
  color: #000000;
  font-size: 14px;
  min-height: 62.5px;
  position: relative;
}
.nonReal ul li div.num {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 23.5px;
  height: 23.5px;
  line-height: 23.5px;
  text-align: center;
  color: #fff;
  background: #b5e8e7;
  border-radius: 100%;
  font-size: 16px;
}
.nonReal ul li {
}
</style>